export const disabledTypesIriForUserArr = [
  "/api/vacation_types/6",  /*Urlop okolicznościowy*/
  "/api/vacation_types/8",  /*Opieka nad dzieckiem*/
  "/api/vacation_types/9",  /*Zwolnienie lekarskie*/
  "/api/vacation_types/10", /*Obecność nieusprawiedliwiona*/
  "/api/vacation_types/12", /*Odbiór za święto*/
  "/api/vacation_types/13", /*Zasiłek Opiekuńczy*/
];
